export default "data:video/mp2t;base64,ZXhwb3J0IHsgVmlzaXRvclNlZ21lbnRhdGlvbk1vZGFsIH0gZnJvbSAiLi9WaXNpdG9yU2VnbWVudGF0aW9uTW9kYWwiOwo="